import React, { useEffect } from "react";
import { Field, reduxForm, stopSubmit,  getFormValues, } from "redux-form";
import { Form, FormGroup, Label, Alert } from "reactstrap";
import { connect } from 'react-redux';

import TextInput from "../../system/fields/TextInput";
import Wysiwyg from "../../system/fields/Wysiwyg";
import FileUpload from "../../system/fields/FileUpload";

let EditForm = (props) => {
  const { handleSubmit, initialValues } = props;

  return (
    <section className="edit-form">
      <Form onSubmit={handleSubmit}>
        <section className="form-section">
          <div className="form-section-header">Cruise Lines Page Details</div>

          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Title</Label>
              <Field
                name="data.data.name"
                component={TextInput}
                placeholder="Enter Page Details"
                // type="text"
              />
            </FormGroup>

            <FormGroup className='col-12'>
              <Label>Hero Image</Label>
              <p className='instruction'>
                Images must be 1920 x 1080 or bigger in the same aspect
                ratio
              </p>
              <Field
                name='data.data.banner_image'
                component={FileUpload}
                files={false}
                images={true}
                type='text'
                className='form-control'
              />
            </FormGroup>

              <FormGroup className="col-12">
              <Label htmlFor="email">Summary</Label>
              <Field
                  name="data.data.summary"
                  type="textarea"
                  placeholder='Enter Page Summary'
                  component={Wysiwyg}
                  // validate={validations.required}
              />
            </FormGroup>
              

            <FormGroup className="col-12">
              <Label htmlFor="email">Description</Label>
              <Field
                  name="data.data.description"
                  placeholder='Enter Page Description'
                  component={Wysiwyg}
                  type="text"
                  // validate={validations.required}
              />
            </FormGroup>
  
          </div>
        </section>
      </Form>

      {props.submitFailed && (
        <div className="error-container">
          <Alert color="danger">
            <strong>There are errors in your form.</strong>
            <br />Please check before submitting again.
          </Alert>
        </div>
      )}
    </section>
  );
};

EditForm = reduxForm({
  form: 'CruiseLinePageForm',
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit('CruiseLinePageForm'));
    }
  },
  destroyOnUnmount: false,
})(EditForm);

const mapStateToProps = (state) => {
  return {
    formValues: getFormValues('CruiseLinePageForm')(state),
    permissions: state.auth.permissions,
    data: state.cruiselinePage.entry,
    loading: state.cruiselinePage.loading
  };
};

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/CruiselinePage/Form.jsx